import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Daniela L.',
  location: 'Guadalajara, México'
}, {
  name: 'Carolina L.',
  location: 'Bogotá, Colombia'
}, {
  name: 'María V.',
  location: 'Ciudad de México, México'
}, {
  name: 'Sofía M.',
  location: 'Lima, Perú'
}, {
  name: 'Valentina B.',
  location: 'Santiago, Chile'
}, {
  name: 'Gabriela R.',
  location: 'Quito, Ecuador'
}, {
  name: 'Andrea M.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Paola S.',
  location: 'San José, Costa Rica'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-66" data-mp="1qxnumecyrs3w">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-67" data-mp="1qwmh838h6tj0">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-sage/50 bg-white p-4 shadow-xl" data-id="element-68" data-mp="1d57vhon6oe89">
            <div className="mt-0.5 rounded-full bg-brand-sageMist p-2" data-id="element-69" data-mp="1853elxid5hhi">
              <CheckCircle2Icon className="h-5 w-5 text-brand-greenMid" data-id="element-70" data-mp="139xt2zsvi4ty" />
            </div>
            <div data-id="element-71" data-mp="z689ypuywfgb">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-72" data-mp="z8ugqna1aqxh">🔔 Compra verificada • hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-73" data-mp="u9rl1tfy1x26">
                <strong data-id="element-74" data-mp="kj9ln3req15t">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-greenMid" data-id="element-75" data-mp="omperq49pjdr">Botiquín Bach Completo™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}